__turbopack_context__.v({
  "animateDown": "contactdropdown-module-scss-module__Xelnqq__animateDown",
  "contactTitle": "contactdropdown-module-scss-module__Xelnqq__contactTitle",
  "contactcontainer": "contactdropdown-module-scss-module__Xelnqq__contactcontainer",
  "contactcontainerhide": "contactdropdown-module-scss-module__Xelnqq__contactcontainerhide",
  "contactcontainershow": "contactdropdown-module-scss-module__Xelnqq__contactcontainershow",
});
